/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_TitleInputs */

const vi_dashboard_sales_title = /** @type {(inputs: Dashboard_Sales_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng điều khiển bán hàng`)
};

/**

* @param {Dashboard_Sales_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_title = /** @type {((inputs?: Dashboard_Sales_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_title(inputs)
});